<template>
  <!-- -->
  <detail-form>
    <page-button @click="back2List">返回</page-button>
    <el-input v-model="dataValue.attendanceDate" disabled>
      <template #prefix>考勤日期</template>
    </el-input>
    <el-input v-model="dataValue.projectName" disabled>
      <template #prefix>项目</template>
    </el-input>
    <el-input v-model="dataValue.siteName" disabled>
      <template #prefix>工地</template>
    </el-input>
    <el-input v-model="dataValue.classmateName" disabled>
      <template #prefix>班组</template>
    </el-input>
    <el-input v-model="dataValue.lotName" disabled>
      <template #prefix>标段</template>
    </el-input>
    <el-input v-model="dataValue.workersName" disabled v-if="level === 3">
      <template #prefix>劳务人员</template>
    </el-input>
  </detail-form>
</template>

<script>


import DetailForm from "@/components/h5/layout/DetailForm.vue";

export default {
  props: {
    data: {default: () => {}},

    level: {default: 2},
  },
  name: "LAL",
  components: {
    DetailForm
  },
  data() {
    return {
      dataValue: {}
    };
  },
  created() {
    this.dataValue = this.data;
  },
  methods: {
    back2List() {
      this.$emit("back2List");
    }
  }
};
</script>

<style lang="scss" scoped>

</style>